<template>
  <div>
    <div class="d-flex justify-end">
      <div class="d-flex align-center">
        <div class="mr-2">
          {{minIndex}} - {{maxIndex}}
        </div>
        <v-btn icon>
          <v-icon
            @click="page = page -1"
            :disabled="page === 1"
            color="primary"
          >
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon
            @click="page = page + 1"
            :disabled="totalItem <= 20*page"
            color="primary"
          >
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </div>
    </div>
    <ListTaskLite @reloadList="reloadList" @sortTimeAppointment="handleSortAppointment" :tasks="listTask.tasks" :height="400" :type="typeScreen"></ListTaskLite>
  </div>
</template>

<script>
import ListTaskLite from '@/components/trigger_task/ListTaskLite.vue';
import TaskRepository from '@/services/TaskRepository';
import { CARE_ROUTER } from '@/helpers/constant';

export default {
  name: 'BlendedTutorTaskTab',
  props: {
    taskType: {
      type: Number,
      default: null,
    },
    typeScreen: {
      type: String,
      default: '',
    },
    curriculumId: {
      type: Number,
      require: true,
    },
    lmsCoreUserId: {
      type: Number,
      default: () => [],
    },
  },
  components: {
    ListTaskLite,
  },
  created() {
    Bus.$on('reloadListLite', () => {
      this.reloadList();
    });
  },
  data() {
    return {
      page: 1,
      listTask: {
        count: 0,
        tasks: [],
      },
      sortAppointmentSchedule: 'asc',
      CARE_ROUTER,
    };
  },
  methods: {
    handleSortAppointment(sortAppointmentSchedule) {
      this.sortAppointmentSchedule = sortAppointmentSchedule;
      this.reloadList();
    },
    async reloadList() {
      await this.getListTask(this.filterForm);
    },
    async getListTask(filterForm) {
      const result = await TaskRepository.getListTask(filterForm);
      if (result.message === 'Success') {
        this.listTask = _.cloneDeep(result.data);
      }
    },
  },
  computed: {
    filterForm() {
      return {
        page: this.page,
        limit: 20,
        curriculumId: this.curriculumId,
        lmsCoreUserId: this.lmsCoreUserId,
        typeScreen: this.typeScreen,
        sortAppointmentSchedule: this.sortAppointmentSchedule,
        type: this.taskType,
        // eslint-disable-next-line no-nested-ternary
        tutorSchoolLevel: CARE_ROUTER.includes(this.$route.name) ? this.$route.query.tutorSchoolLevel : this.$route.name === 'StudentDetailBlended' ? this.$route.query.schoolLevel : '',
      };
    },
    totalItem() {
      return this.listTask.count;
    },
    maxIndex() {
      if (this.page * 20 < this.totalItem) {
        return this.page * 20;
      } return this.totalItem;
    },
    minIndex() {
      return (this.page - 1) * 20 + 1;
    },
  },
  watch: {
    page() {
      this.getListTask(this.filterForm);
    },
    curriculumId: {
      handler() {
        this.getListTask(this.filterForm);
      },
      immediate: true,
    },
  },
  destroyed() {
    Bus.$off('reloadListLite');
  },
};
</script>

<style scoped>

</style>
